// extracted by mini-css-extract-plugin
export default {"modal":"terms_of_service_modal-module___modal___c31b4dae"};